import { Form } from 'antd'
import styles from '@/pages/login/index.module.less'
import PasswordInput from '@/components/PasswordInput'
import OkButton from '@/pages/login/modules/OkButton.tsx'
import useValidate from '@/hooks/useValidate.ts'
import { useDebounceEffect, useSetState } from 'ahooks'
import classNames from 'classnames'
import animationQueue, { AnimateView, VIEW_POSITION } from './modules/animationQueueControl'
import { forwardRef, memo, useImperativeHandle } from 'react'
import { PanelTitle } from '@/pages/login/loginResetPassword.tsx'

/** 初次登录 强制修改密码 **/
const LoginInitialPassword = forwardRef((props: any, ref) => {
  const { onFinish } = props
  const [state, setState] = useSetState({
    loading: false,
  })
  const INITIAL_PASSWORD = 'initial_password'

  const [form] = Form.useForm()

  const [validateHelper] = useValidate()

  useDebounceEffect(
    () => {
      animationQueue.insert(
        new AnimateView({ id: INITIAL_PASSWORD, position: VIEW_POSITION.hide }),
        3
      )
    },
    [],
    { wait: 200 }
  )

  const onBack = () => {
    animationQueue.jump(0)
  }

  const handleFinish = async () => {
    return form.validateFields().then(values => {
      const { initPassword, initRepeatPassword, ...rest } = values
      const res = onFinish?.({
        password: initPassword,
        repeatPassword: initRepeatPassword,
        ...rest,
      })
      if (res instanceof Promise) {
        setState({ loading: true })
        res.finally(() => {
          setState({ loading: false })
        })
      }
    })
  }

  return (
    <div className={classNames(styles.floatView)} id={INITIAL_PASSWORD}>
      <PanelTitle title="修改初始密码" onBack={onBack} className={styles.mb60} />
      <div
        style={{
          color: '#888',
          padding: '10px 0',
          marginTop: 12,
          marginBottom: 12,
          lineHeight: '28px',
          fontSize: '12px',
        }}
      >
        鉴于您初次登录应用平台，请您设置您的密码
      </div>
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        <Form.Item
          name="initPassword"
          required
          rules={[validateHelper.password('initRepeatPassword')]}
          className={styles.formItem}
        >
          <PasswordInput className={styles.formInput} placeholder="请输入新密码" />
        </Form.Item>
        <Form.Item
          name="initRepeatPassword"
          required
          rules={[validateHelper.password('initPassword', { message: '请确认新密码' })]}
          className={styles.formItem}
        >
          <PasswordInput className={styles.formInput} placeholder="请确认新密码" />
        </Form.Item>
        <OkButton loading={state.loading}>确定</OkButton>
      </Form>
    </div>
  )
})

export default LoginInitialPassword
